import { render, staticRenderFns } from "./ItemsGuestFlow.vue?vue&type=template&id=3565f36d&scoped=true&v-on-clickaway=cancel&"
import script from "./ItemsGuestFlow.vue?vue&type=script&lang=ts&"
export * from "./ItemsGuestFlow.vue?vue&type=script&lang=ts&"
import style0 from "./ItemsGuestFlow.vue?vue&type=style&index=0&id=3565f36d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3565f36d",
  null
  
)

export default component.exports